import axios from "axios";
import * as headers from "./auth-header";

const apiUrl = process.env.REACT_APP_API_URL;

export function getAllFamilies(page, limit, filter) {
  return axios.get(apiUrl + `family/all/${page}/${limit}?key=${filter}`, {
    headers: headers.authHeader(),
  });
}

export function getFamilyById(familyId) {
  return axios.get(apiUrl + `family/${familyId}`, {
    headers: headers.authHeader(),
  });
}
